import React from 'react';

const ModelCard = ({ title, icon, modelName, accuracy, dataCount }) => {
  const getAccuracyColor = (acc) => {
    if (acc >= 0.9) return 'text-green-600';
    if (acc >= 0.8) return 'text-yellow-600';
    return 'text-red-600';
  };

  const getAccuracyBg = (acc) => {
    if (acc >= 0.9) return 'bg-green-100';
    if (acc >= 0.8) return 'bg-yellow-100';
    return 'bg-red-100';
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
      <div className="flex items-center mb-4">
        <span className="text-3xl mr-3">{icon}</span>
        <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
      </div>

      <div className={`${getAccuracyBg(accuracy)} rounded-lg p-4 mb-3`}>
        <div className={`text-3xl font-bold ${getAccuracyColor(accuracy)}`}>
          {(accuracy * 100).toFixed(1)}%
        </div>
        <div className="text-sm text-gray-600 mt-1">정확도</div>
      </div>

      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-600">모델:</span>
          <span className="font-medium">{modelName}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">학습 데이터:</span>
          <span className="font-medium">{dataCount}개</span>
        </div>
      </div>
    </div>
  );
};

export default ModelCard;
